import type { ApolloError } from '@apollo/client/core'

export type GraphqlFailure<T> = Extract<T, { errors: unknown[] }>

export type GraphqlSuccess<T> = Exclude<T, { errors: unknown[] }>

export const createTypenameGuard =
  <TBase extends { __typename: string }, TName extends TBase['__typename']>(
    typename: TName,
  ) =>
  (obj: TBase): obj is Extract<TBase, { __typename: TName }> =>
    obj.__typename === typename

export const isApolloError = (error: any | ApolloError): error is ApolloError =>
  !!(error as ApolloError)?.graphQLErrors?.length

export const isGraphqlFailure = <T>(
  obj: null | T | undefined,
): obj is GraphqlFailure<T> =>
  !!obj && typeof obj === 'object' && (obj as any).errors != null

export const isGraphqlSuccess = <T>(
  obj: null | T | undefined,
): obj is GraphqlSuccess<T> =>
  !obj || typeof obj !== 'object' || (obj as any).errors == null

export const hasGraphqlError = <TErrors extends { __typename: string }>(
  errors: TErrors[],
  typename: TErrors['__typename'],
) => errors.some(({ __typename }) => __typename === typename)
